module.exports = kolibriGlobal.coreVue.components.KButton;